import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('fx_user');
    const token = localStorage.getItem('fx_token');
    if (stored && token) {
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('fx_token', data.token);
    localStorage.setItem('fx_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('fx_token');
    localStorage.removeItem('fx_user');
    setUser(null);
  };

  const isAdmin = () => user?.role === 'admin';
  const isManager = () => user?.role === 'admin' || user?.role === 'manager';

  // Check if user has access to a specific module
  const canAccess = (module) => {
    if (!user) return false;
    if (user.role === 'admin') return true; // Admin always has full access
    return user.modules?.[module] === true;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isManager, canAccess }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
